import type { IAccountTenantInput, IAccountWithAccountTenant, IContinuationResult, ISubscriptionWithTransactions, ITenant, ITenantInput, ITenantWithOwner } from '../../../api/api'
import { omit } from '../util'
import { apiSlice } from './apiSlice'

export const adminTenantsApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAdminTenants: builder.query<ITenant[], void>({ // eslint-disable-line @typescript-eslint/no-invalid-void-type
      query: () => '/admin/tenants',
      transformResponse: (responseData: IContinuationResult<ITenant>) => {
        // return responseData?.items ? responseData?.items.map(unmarshalList) : []
        return responseData?.items ?? []
      },

      providesTags: (result = [], _error, _arg) => [
        'AdminTenant',
        ...result.map(({ id }) => ({ type: 'AdminTenant' as const, id }))
      ]
    }),
    getAdminTenantsFull: builder.query<ITenantWithOwner[], void>({ // eslint-disable-line @typescript-eslint/no-invalid-void-type
      query: () => '/admin/tenants/full',
      providesTags: (result = [], _error, _arg) => [
        'AdminTenantFull',
        ...result.map(({ id }) => ({ type: 'AdminTenantFull' as const, id }))
      ]
    }),
    getAdminTenant: builder.query<ITenant | undefined, string>({
      query: (tenantId: string) => `/admin/tenants/${tenantId}`,
      // transformResponse: (responseData: List) => {
      //   return responseData ? unmarshalList(responseData) : undefined
      // },
      providesTags: (_result, _error, arg) => [{ type: 'AdminTenant', id: arg }]
    }),
    addAdminTenant: builder.mutation<ITenant, ITenantInput>({
      query: (newTenant: ITenantInput) => ({
        url: '/admin/tenants',
        method: 'POST',
        body: newTenant
      }),
      invalidatesTags: (result, _error, _arg) => ['AdminTenant', { type: 'AdminTenant', id: result?.id }]
    }),
    editAdminTenant: builder.mutation({
      query: (tenant: Partial<ITenantInput> & { id: string }) => ({
        url: `/admin/tenants/${tenant.id}`,
        method: 'PUT',
        body: tenant
      }),
      invalidatesTags: (result, _error, _arg) => [{ type: 'AdminTenant', id: result?.id }]
    }),
    deleteAdminTenant: builder.mutation({
      query: (id: { tenantId: string }) => ({
        url: `/admin/tenants/${id.tenantId}`,
        method: 'DELETE'
      }),
      invalidatesTags: (_result, _error, arg) => ['AdminTenant', { type: 'AdminTenant', id: arg.tenantId }]
    }),
    getAdminTenantAccounts: builder.query<IAccountWithAccountTenant[], string>({
      query: (tenantId: string) => `/admin/tenants/${tenantId}/accounts`,
      // transformResponse: (responseData: List) => {
      //   return responseData ? unmarshalList(responseData) : undefined
      // },
      providesTags: (result = [], _error, _arg) => [
        'AdminAccountTenant',
        ...result.map(({ accountTenant }) => ({ type: 'AdminAccountTenant' as const, id: `${accountTenant?.accountId}#${accountTenant?.tenantId}` }))
      ]
    }),
    addAdminTenantAccount: builder.mutation<IAccountWithAccountTenant, IAccountTenantInput>({
      query: (input: IAccountTenantInput) => ({
        url: `/admin/tenants/${input.tenantId}/accounts/${input.accountId}`,
        method: 'POST',
        body: omit(input, 'tenantId', 'accountId')
      }),
      invalidatesTags: (_result, _error, arg) => ['AdminAccountTenant', { type: 'AdminAccountTenant', id: `${arg.accountId}#${arg.tenantId}` }]
    }),
    editAdminTenantAccount: builder.mutation<IAccountWithAccountTenant, IAccountTenantInput>({
      query: (input: IAccountTenantInput) => ({
        url: `/admin/tenants/${input.tenantId}/accounts/${input.accountId}`,
        method: 'PUT',
        body: omit(input, 'tenantId', 'accountId')
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'AdminAccountTenant', id: `${arg.accountId}#${arg.tenantId}` }]
    }),
    deleteAdminTenantAccount: builder.mutation({
      query: (id: { tenantId: string, accountId: string }) => ({
        url: `/admin/tenants/${id.tenantId}/accounts/${id.accountId}`,
        method: 'DELETE'
      }),
      invalidatesTags: (_result, _error, arg) => ['AdminAccountTenant', { type: 'AdminAccountTenant', id: `${arg.accountId}#${arg.tenantId}` }]
    }),
    getAdminTenantTransactions: builder.query<ISubscriptionWithTransactions[], string>({
      query: (tenantId: string) => `/admin/tenants/${tenantId}/transactions`
      // transformResponse: (responseData: List) => {
      //   return responseData ? unmarshalList(responseData) : undefined
      // },
    })
  })
})

// Export the auto-generated hook for the `getPosts` query endpoint
export const {
  useGetAdminTenantsQuery,
  useGetAdminTenantsFullQuery,
  useGetAdminTenantQuery,
  useAddAdminTenantMutation,
  useEditAdminTenantMutation,
  useDeleteAdminTenantMutation,
  useGetAdminTenantAccountsQuery,
  useAddAdminTenantAccountMutation,
  useEditAdminTenantAccountMutation,
  useDeleteAdminTenantAccountMutation,
  useGetAdminTenantTransactionsQuery
} = adminTenantsApiSlice
